import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
  CircularProgress,
  Box,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export default function DeleteConfirmDialog({
  open,
  onClose,
  client,
  onConfirm,
  loading,
}) {
  const handleConfirm = () => {
    onConfirm?.(client);
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          bgcolor: "secondary.main",
          color: "common.white",
          borderBottom: "1px solid",
          borderColor: "primary.main",
          px: 3,
          py: 2,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700} color="inherit">
            Delete client
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "rgba(255, 255, 255, 0.75)", mt: 0.25 }}
          >
            Hide this client from active lists.
          </Typography>
        </Box>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          disabled={loading}
          size="small"
          sx={{
            color: "primary.main",
            mt: 0.25,
            "&:hover": { bgcolor: "rgba(197, 160, 111, 0.16)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>
        <Typography sx={{ mb: 2, mt: 1 }}>
          Are you sure you want to delete{" "}
          <strong>
            {client?.client_first_name} {client?.client_last_name}
          </strong>
          ?
        </Typography>
        <Alert severity="warning" sx={{ fontSize: "0.85rem" }}>
          This will hide the client from all views. Their appointment history
          will be preserved. You can restore them later from the &ldquo;Deleted&rdquo; tab.
        </Alert>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          borderTop: "1px solid",
          borderColor: "divider",
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          color="secondary"
          sx={{ textTransform: "none", minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }
          sx={{ textTransform: "none", fontWeight: 700, minWidth: 100 }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
